/** Original Hush token colours. Kept exact, including casing, for stable legacy art. */
export const LEGACY_PIECE_PALETTES = {
    coastal_salt: {
      outline: '#2B4145', outlineSoft: '#586D69', paperBase: '#D7BC83', paperLight: '#F0DEB0', paperShadow: '#A88A54',
      warmCore: '#FFE3A0', woodBase: '#826B4D', woodLight: '#A18A61', woodShadow: '#594C3B',
      clothBlue: '#6C9BAE', clothBlueLight: '#AAC8CE', clothBlueShadow: '#426C7D',
      reedBase: '#84956C', reedLight: '#AFB68A', reedShadow: '#5D7459',
      stoneBase: '#8C9C96', stoneLight: '#B5BDA7', stoneShadow: '#627873', moss: '#78966B', salt: '#D1D6BF',
      waterFar: '#527E86', waterLight: '#A9C7C4',
    },
    nook_warm: {
      outline: '#2B4145', outlineSoft: '#586D69', paperBase: '#E5C991', paperLight: '#F5E4BF', paperShadow: '#A88A54',
      warmCore: '#FFE8AB', woodBase: '#927754', woodLight: '#A18A61', woodShadow: '#594C3B',
      clothBlue: '#6C9BAE', clothBlueLight: '#AAC8CE', clothBlueShadow: '#426C7D',
      reedBase: '#8D9B73', reedLight: '#AFB68A', reedShadow: '#5D7459',
      stoneBase: '#949F8B', stoneLight: '#B5BDA7', stoneShadow: '#687C6B', moss: '#78966B', salt: '#D1D6BF',
      waterFar: '#527E86', waterLight: '#A9C7C4',
    },
    icon_ink: {
      outline: '#253A42', outlineSoft: '#586D69', paperBase: '#DBBF7F', paperLight: '#F9E5B5', paperShadow: '#A88A54',
      warmCore: '#FFE9A6', woodBase: '#826B4D', woodLight: '#A18A61', woodShadow: '#594C3B',
      clothBlue: '#6C9BAE', clothBlueLight: '#AAC8CE', clothBlueShadow: '#426C7D',
      reedBase: '#84956C', reedLight: '#AFB68A', reedShadow: '#5D7459',
      stoneBase: '#85AAA5', stoneLight: '#BED4C1', stoneShadow: '#627873', moss: '#78966B', salt: '#D1D6BF',
      waterFar: '#527E86', waterLight: '#A9C7C4',
    },
  } as const;
